module Client.View

open Fable.React
// open Fable.React.Props
open Client.Shared
open Client
open Client.Styles
open global.Elmish
open Fable.Core.JsInterop
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons

let handleNotFound (model : Model) =
  model, Cmd.none

/// Constructs the view for a page given the model and dispatcher.
let viewPage model dispatch =
  let pageContent =
    match model with
    | TempLoggedIn _ -> // TODO: Handle TempLoggedIn case
      Components.PasswordChange.passwordChangeModal
        {|
          isOpen = true
          onClose = (fun _ -> dispatch (GoTo Pages.Page.Login))
          onSubmit = (fun newPassword ->
            // Dispatch an action to change the password
            dispatch (PasswordChanged))
        |}

    | LoggedIn loggedInModel ->
      match model.route with
      // Pages not requiring auth
      | Pages.Page.MeterReadings -> MeterReadings.view ({| equipmentOption = None; reCaptchaSiteKey = model.reCaptchaSiteKey; |})
      | Pages.Page.ServiceCalls -> ServiceCalls.view ({| equipmentOption = None; reCaptchaSiteKey = model.reCaptchaSiteKey; |})
      | Pages.Page.Supplies -> Supplies.view ({| equipmentOption = None; reCaptchaSiteKey = model.reCaptchaSiteKey; |})
      | Pages.Page.EquipmentLookup equipmentOrSerialNumber -> Equipment.view ({| reCaptchaSiteKey = model.reCaptchaSiteKey; equipmentOrSerialNumberOption = Some equipmentOrSerialNumber; |})
      | Pages.Page.Equipment -> Equipment.view ({| reCaptchaSiteKey = model.reCaptchaSiteKey; equipmentOrSerialNumberOption = None; |})
      | Pages.Page.Login -> Login.view {| reCaptchaSiteKey = model.reCaptchaSiteKey; parentDispatch = dispatch |}

      // Pages requiring auth
      | Pages.Page.Location customerId -> Location.view {| model = loggedInModel; customerId = customerId |}
      | Pages.Page.Locations -> Locations.view {| model = loggedInModel |}
      | Pages.Page.LocationEquipment (customerId, equipmentId) -> LocationEquipment.view {| model = loggedInModel; customerId = customerId; equipmentId = equipmentId; |}
      | Pages.Page.LocationEquipments customerId -> LocationEquipments.view {| model = loggedInModel; customerId = customerId |}
      | Pages.Page.LocationInvoice (customerId, invoiceId) -> LocationInvoice.view {| model = loggedInModel; customerId = customerId; invoiceId = invoiceId; |}
      | Pages.Page.LocationInvoices customerId -> LocationInvoices.view {| model = loggedInModel; customerId = customerId; |}

      | Pages.Page.Home -> Home.view {| parentModel = loggedInModel; parentDispatch = dispatch |}

    | LoggedOut loggedOutModel ->
      match model.route with
      // Pages not requiring auth
      | Pages.Page.MeterReadings -> MeterReadings.view ({| equipmentOption = None; reCaptchaSiteKey = model.reCaptchaSiteKey; |})
      | Pages.Page.ServiceCalls -> ServiceCalls.view ({| equipmentOption = None; reCaptchaSiteKey = model.reCaptchaSiteKey; |})
      | Pages.Page.Supplies -> Supplies.view ({| equipmentOption = None; reCaptchaSiteKey = model.reCaptchaSiteKey; |})
      | Pages.Page.EquipmentLookup equipmentOrSerialNumber -> Equipment.view ({| reCaptchaSiteKey = model.reCaptchaSiteKey; equipmentOrSerialNumberOption = Some equipmentOrSerialNumber; |})
      | Pages.Page.Equipment -> Equipment.view ({| reCaptchaSiteKey = model.reCaptchaSiteKey; equipmentOrSerialNumberOption = None; |})

      | Pages.Page.Login -> Login.view {| reCaptchaSiteKey = model.reCaptchaSiteKey; parentDispatch = dispatch |}

      // Pages requiring auth
      | Pages.Page.Location _
      | Pages.Page.Locations
      | Pages.Page.LocationEquipment _
      | Pages.Page.LocationEquipments _
      | Pages.Page.LocationInvoice _
      | Pages.Page.LocationInvoices _

      | Pages.Page.Home -> Login.view {| reCaptchaSiteKey = model.reCaptchaSiteKey; parentDispatch = dispatch |}
  pageContent
  // Html.div [
  //   match model.authStatus with
  //   | AuthStatus.LoggedIn _ ->
  //     Client.Components.Navbar.navBar (model, dispatch)
  //   | AuthStatus.LoggedOut -> ()

  //   Html.main [
  //     prop.style [ style.padding 20 ]
  //     prop.children [ pageContent ]
  //   ]
  // ]

type MenuItemInfo = { Page : Pages.Page; DisplayText : string; }
type MenuCategoryInfo = { Category : string; Items : MenuItemInfo list; }

let viewMenu = React.functionComponent (fun (inputProps: {| menuItems : MenuCategoryInfo list; |}) ->
  let menuItems: MenuCategoryInfo list = [{ Category = "General"; Items = [ { Page = Pages.Page.Home; DisplayText = "Home" }; { Page = Pages.Page.Locations; DisplayText = "Locations" }; ]; }]
  let menuContainer = React.functionComponent(fun (name: string, children: seq<ReactElement>) ->
    let isOpen, setIsOpen = React.useState true
    React.fragment [
      Mui.listItem [
        prop.onClick (fun _ -> setIsOpen (not isOpen))
        listItem.button false
        listItem.children [
          Mui.listItemText name
        ]
      ]
      Mui.collapse [
        collapse.in' true
        collapse.children [
          Mui.list [
            // list.disablePadding true
            list.children children
          ]
        ]
      ]
    ]
  )

  let menuItem (item: MenuItemInfo) =
    Mui.listItem [
      // prop.key fragment
      prop.href (Client.Pages.toHash item.Page)
      // if isNested then
      //listItem.classes.root c.nestedMenuItem
      prop.style [ style.paddingLeft 30 ]
      listItem.button true
      listItem.component' "a"
      // listItem.selected ((model.CurrentPath = path))
      listItem.children [
        Mui.listItemText item.DisplayText
      ]
    ]

  Mui.list [
    list.component' "nav"
    list.children [
      for menuCategoryInfo in menuItems do
        menuContainer
          ( menuCategoryInfo.Category,
            menuCategoryInfo.Items |> List.map menuItem )
    ]
  ]
)

let App = FunctionComponent.Of((fun (model, dispatch) ->
  let c = Styles.useStyles ()
  let initialDrawerIsOpen = false
  let drawerIsOpen, setDrawerIsOpen = React.useState initialDrawerIsOpen
  let anchorEl, setAnchorEl = React.useState(Option<Browser.Types.Element>.None)
  let isOpen = anchorEl.IsSome
  let handleMenu (event : Browser.Types.Event) = setAnchorEl (Some (event.currentTarget :?> Browser.Types.Element))
  let handleClose () = setAnchorEl None
  let initialPasswordModalIsOpen =
    //Browser.Dom.console.log("AuthStatus: ", sprintf "%A" model)
    match model with
    | LoggedIn _  -> false
    | TempLoggedIn _ -> true
    | LoggedOut _ -> false
  let isChangePasswordModalOpen, setChangePasswordModalOpen = React.useState(initialPasswordModalIsOpen)
  let handleChangePasswordSubmit (newPassword: string) =
    // Dispatch an action to update the password
    // dispatch (ChangePassword newPassword)
    setChangePasswordModalOpen false

  Html.div [
    Mui.cssBaseline []
    match model with
    | LoggedOut _ -> viewPage model dispatch
    | TempLoggedIn _
    | LoggedIn _ ->
      Html.div [
        prop.className c.root
        prop.children [
          Mui.cssBaseline []
          Mui.appBar [
            prop.className [
              c.appBar
              if drawerIsOpen then c.appBarShift
            ]
            appBar.color.default'
            appBar.position.fixed'
            appBar.children [
              Mui.toolbar [
                Mui.iconButton [
                  prop.className [
                    c.menuButton
                    if drawerIsOpen then c.hide
                  ]
                  iconButton.edge.start
                  iconButton.children [ menuIcon [] ]
                  prop.onClick (fun _ -> setDrawerIsOpen (not drawerIsOpen))
                ]
                Html.img [
                  prop.src "/logo.png"
                ]
                Mui.typography [
                  typography.variant.h5
                  prop.style [ style.flexGrow 1 ]
                  typography.children [ Html.text "" ]
                ]
                Mui.iconButton [
                  iconButton.color.inherit'
                  prop.onClick handleMenu
                  iconButton.children (accountCircleIcon [])
                ]
                Mui.menu [
                  menu.anchorEl anchorEl
                  menu.anchorOrigin (PopoverOriginHorizontal.Right, PopoverOriginVertical.Top)
                  menu.keepMounted true
                  menu.transformOrigin (PopoverOriginHorizontal.Right, PopoverOriginVertical.Top)
                  menu.open' isOpen
                  menu.onClose (fun _ -> handleClose ())
                  menu.children [
                    Mui.menuItem [
                      prop.onClick (fun _ -> dispatch Logout)
                      prop.children [
                        Mui.grid [
                          grid.container true
                          grid.alignItems.center
                          grid.spacing._2
                          grid.children [
                            Mui.grid [
                              grid.item true
                              grid.children [
                                Mui.typography [
                                  typography.color.textPrimary
                                  typography.children "Sign out"
                                ]
                              ]
                            ]
                            Mui.grid [
                              grid.item true
                              grid.children [
                                logoutIcon []
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                    Mui.menuItem [
                      prop.onClick (fun _ ->
                          handleClose ()
                          setChangePasswordModalOpen true
                        )
                      prop.children [
                        Mui.grid [
                          grid.container true
                          grid.alignItems.center
                          grid.spacing._2
                          grid.children [
                            Mui.grid [
                              grid.item true
                              grid.children [
                                Mui.typography [
                                  typography.color.textPrimary
                                  typography.children "Change password"
                                ]
                              ]
                            ]
                            Mui.grid [
                              grid.item true
                              grid.children [
                                keyIcon []
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
          Components.PasswordChange.passwordChangeModal {|
            isOpen = isChangePasswordModalOpen
            onClose = (fun _ -> setChangePasswordModalOpen false)
            onSubmit = handleChangePasswordSubmit
          |}

          Mui.drawer [
            drawer.classes.root c.drawer
            drawer.classes.paper c.drawerPaper
            drawer.anchor.left
            drawer.open' drawerIsOpen
            drawer.variant.persistent
            drawer.children [
              Html.div [
                prop.className c.drawerHeader
                prop.children [
                  Mui.iconButton [
                    iconButton.children [
                      if drawerIsOpen then chevronLeftIcon [ ] else chevronRightIcon [ ] ]
                    prop.onClick (fun _ -> setDrawerIsOpen false)
                  ]
                ]
              ]
              Mui.divider [ ]

              let menuItems: MenuCategoryInfo list = [{ Category = "General"; Items = [ { Page = Pages.Page.Home; DisplayText = "Home" }; { Page = Pages.Page.Locations; DisplayText = "Locations" }; ]; }]
              viewMenu {| menuItems = menuItems |}
            ]
          ]

          Html.main [
            prop.className [
              c.content
              if drawerIsOpen then c.contentShift
            ]
            prop.children [
              Html.div [ prop.className c.drawerHeader ]
              viewPage model dispatch
            ]
          ]
        ]
      ]
  ]

), "App", memoEqualsButFunctions)

let root (model: Model) (dispatch : (Msg -> unit)) =
    App (model, dispatch)